import { useEffect } from 'react';
import { usePubNub } from 'pubnub-react';
import type { MessageEvent } from 'pubnub';
import {
  useDebouncedInvalidateTotalUnread,
  useCurrentUser,
  useMe
} from '../../hooks';
import { findPersonalChannelOrganizationId } from '../../utils/personalChannels';

export function UnreadCountInvalidator() {
  const pubnub = usePubNub();
  const { data: currentUser } = useCurrentUser();
  const invalidateTotalUnread = useDebouncedInvalidateTotalUnread();
  const { data: me } = useMe();
  const memberships = me?.memberships;

  useEffect(() => {
    if (!pubnub || !currentUser?.uuid) return;

    const handleMessage = (event: MessageEvent) => {
      // 管理者自身が送信したメッセージでは未読数を更新しない
      if (event.publisher === currentUser?.uuid) return;
      // 個人チャネルは組織を判定できる AppLayout が扱う（別組織のイベントで選択中の未読を取り直さない）
      if (findPersonalChannelOrganizationId(memberships, event.channel) !== null) return;
      invalidateTotalUnread();
    };

    pubnub.addListener({ message: handleMessage });

    return () => {
      pubnub.removeListener({ message: handleMessage });
    };
  }, [pubnub, currentUser?.uuid, invalidateTotalUnread, memberships]);

  return null;
}
